import { __ } from '@wordpress/i18n';
import { PanelBody, PanelRow } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import DynamicShortcodeInput from '../components/dynamicShortcode';
import { TestimonialFormPreviewImage } from '../../assets/testimonialIcons';
import { addScriptsOnBody, getElementById } from '../controls/controls';
import { useEffect } from '@wordpress/element';
const { serverSideRender: ServerSideRender } = wp;

const TestimonialEditForm = ( { attributes, setAttributes } ) => {
	const { shortCodeList, formConfig } = sp_testimonial_form;
	const { shortcode, isAvailableId } = attributes;

	const scriptLoad = ( shortcodeId ) => {
		let sptpBlockLoaded = false;

		const sptpBlockLoadedInterval = setInterval( function () {
			let formWrapper = getElementById(
				'testimonial_form_' + shortcodeId
			);
			if ( formWrapper ) {
				addScriptsOnBody( formConfig );
				sptpBlockLoaded = true;
				// formWrapper = '';
			}
			if ( sptpBlockLoaded || shortcodeId === 0 ) {
				clearInterval( sptpBlockLoadedInterval );
			}
		}, 10 );
	};

	useEffect( () => {
		if ( isAvailableId ) {
			scriptLoad( shortcode );
		}
	}, [ shortcode ] );

	const updateShortcode = ( selectedShortcode ) => {
		setAttributes( { shortcode: selectedShortcode, isAvailableId: true } );
		scriptLoad( selectedShortcode );
	};

	if ( attributes.preview ) {
		return <TestimonialFormPreviewImage />;
	}

	if ( shortCodeList.length === 0 ) {
		return (
			<div className="components-placeholder is-large sptp_block_shortcode">
				<div className="components-placeholder__label">
					<img
						className="block-editor-block-icon"
						src={ `${ sp_testimonial_pro.url }Admin/GutenbergBlock/assets/testimonial-form.svg` }
						alt="Testimonial Form Icon"
					/>
					<h4>{ __( 'Testimonial Forms', 'testimonial-pro' ) }</h4>
				</div>
				<div className="sptp_block_shortcode_text">
					<span>
						{ __( 'No view shortcode found. ', 'testimonial-pro' ) }
					</span>
					<a href={ sp_testimonial_pro.link }>
						{ __( 'Create a view now!', 'testimonial-pro' ) }
					</a>
				</div>
			</div>
		);
	}

	if ( ! attributes.shortcode || attributes.shortcode == 0 ) {
		return (
			<>
				<InspectorControls>
					<PanelBody
						title={ __(
							'Select a view (shortcode)',
							'testimonial-pro'
						) }
					>
						<PanelRow>
							<DynamicShortcodeInput
								attributes={ attributes }
								shortCodeList={ shortCodeList }
								shortcodeUpdate={ updateShortcode }
							/>
						</PanelRow>
					</PanelBody>
				</InspectorControls>
				<div className="components-placeholder is-large sptp_block_shortcode">
					<div className="components-placeholder__label">
						<img
							className="block-editor-block-icon"
							src={ `${ sp_testimonial_pro.url }Admin/GutenbergBlock/assets/testimonial-form.svg` }
							alt="Testimonial Form Icon"
						/>
						<span>
							{ __( 'Testimonial Forms', 'testimonial-pro' ) }
						</span>
					</div>
					<div className="components-placeholder__instructions">
						{ __( 'Select a view (shortcode)', 'testimonial-pro' ) }
					</div>
					<DynamicShortcodeInput
						attributes={ attributes }
						shortCodeList={ shortCodeList }
						shortcodeUpdate={ updateShortcode }
					/>
				</div>
			</>
		);
	}

	return (
		<>
			<InspectorControls>
				<PanelBody
					title={ __(
						'Testimonials Forms Block Settings',
						'testimonial-pro'
					) }
				>
					<PanelRow>
						<DynamicShortcodeInput
							attributes={ attributes }
							shortCodeList={ shortCodeList }
							shortcodeUpdate={ updateShortcode }
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>
			<ServerSideRender
				block="sp-testimonial-pro/form"
				attributes={ attributes }
			/>
		</>
	);
};

export default TestimonialEditForm;
